/**
 * @generated SignedSource<<19993e3d66ffa78aebc5796db9d821cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarItemInfo_transaction$data = {
  readonly sku: {
    readonly leadTime: string | null;
  } | null;
  readonly skuVariableAttributeRows: ReadonlyArray<{
    readonly label: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"RingSizeDisplay_transaction">;
  readonly " $fragmentType": "CheckoutSidebarItemInfo_transaction";
};
export type CheckoutSidebarItemInfo_transaction$key = {
  readonly " $data"?: CheckoutSidebarItemInfo_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarItemInfo_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarItemInfo_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RingSizeDisplay_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeRow",
      "kind": "LinkedField",
      "name": "skuVariableAttributeRows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "Checkout"
            }
          ],
          "kind": "ScalarField",
          "name": "leadTime",
          "storageKey": "leadTime(pageType:\"Checkout\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "f49a9f165f797add18112bdb2804e7ff";

export default node;
